import { Link } from "react-router-dom";
import SectionTitle from "../sectionTitle/SectionTitle";

const pad2 = (n) => String(n).padStart(2, "0");

const ProcessTimelineSplit = ({
  id,
  eyebrow,
  title,
  description,
  steps = [],
  ctaLabel,
  ctaHref,
}) => {
  const isCtaExternal =
    typeof ctaHref === "string" && ctaHref.startsWith("http");

  return (
    <section className="rn-section-gap pt--0 process-timeline-split" id={id}>
      <div className="container">
        <div className="row row--30">
          <div className="col-lg-5 col-12 process-left">
            <SectionTitle
              textAlign="text-left"
              radiusRounded=""
              subtitle={eyebrow}
              title={title}
              description={description}
            />
            {!!ctaLabel && !!ctaHref && (
              isCtaExternal ? (
                <a
                  className="btn-default btn-large round btn-icon process-cta"
                  href={ctaHref}
                  target="_blank"
                  rel="noreferrer"
                >
                  {ctaLabel}
                </a>
              ) : (
                <Link
                  className="btn-default btn-large round btn-icon process-cta"
                  to={ctaHref}
                >
                  {ctaLabel}
                </Link>
              )
            )}
          </div>

          <div className="col-lg-7 col-12 mt_md--40 mt_sm--40 process-right">
            <div className="process-timeline">
              <div className="process-line" aria-hidden="true" />
              {(steps || []).map((step, idx) => (
                <div className="process-item" key={idx}>
                  <div className="process-node">
                    <span>{pad2(idx + 1)}</span>
                  </div>
                  <div className="process-body">
                    {!!step?.title && (
                      <h4 className="process-step-title">{step.title}</h4>
                    )}
                    {!!step?.description && (
                      <p className="process-step-desc">{step.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessTimelineSplit;

